import React from 'react';

function Introduction() {
  return (
    <div>
      <div className="font-mono text-teal-300 py-1">Hi, I'm</div>
      <div className="font-sans py-4 font-medium md:text-6xl text-4xl">Anand Krishna.</div>
      <div className="py-2">
        <div className="md:text-3xl text-xl font-medium font-sans text-slate-300">
          I write code the way
          <span className="text-teal-300"> I think </span>
        </div>
      </div>
      <div className="font-sans py-4 font-medium md:text-xl text-slate-400">
        <span className="text-teal-300"> carefully, </span>
        with
        <span className="text-teal-300"> structure, </span>
        and usually about finding something faint in a
        <span className="text-teal-300"> noisy signal. </span>
        <span className="text-slate-300">Statistician who builds software.</span>
        {' '}Lately that's been
        <span className="text-teal-300"> turbine sensors, LLM tooling </span>
        and
        <span className="text-teal-300"> sungrazing comets. </span>
      </div>
    </div>
  );
}

export default Introduction;